import { constantRoutes, memberRoutes, adminRoutes, agentRoutes, mobileRoutes,employeeRoutes } from '@/router'
import { isMobile } from "@/utils/tools.js";
const state = {
  permissionRoutes: [],
  routes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.permissionRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  // 獲取權限路由
  generateRoutes({ commit }, userInfo) {
    return new Promise(resolve => {
      let accessedRoutes
      const redirectPath = { path: '*', redirect: '/', hidden: true }//匹配失敗就到首頁
      if(isMobile()) {
        accessedRoutes = [...mobileRoutes, redirectPath]
      } else {
        if (userInfo.type === 1) {
          accessedRoutes = [...memberRoutes,...mobileRoutes, ...adminRoutes, ...employeeRoutes, ...agentRoutes, redirectPath]
        } else if (userInfo.type === 2) {
          accessedRoutes = [...memberRoutes,...mobileRoutes, ...agentRoutes, ...employeeRoutes, redirectPath]
        } else if(userInfo.type === 3) {
          accessedRoutes = [...memberRoutes,...mobileRoutes, ...employeeRoutes, redirectPath]
        }else{
          accessedRoutes = [...mobileRoutes, ...employeeRoutes, redirectPath]
        }
      }
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  },
}

export default {
  state,
  mutations,
  actions
}